export default __webpack_public_path__ + "static/logo-b66ccb6663e7003f8846790460736cc7.png";